export const SERVICE_ERROR_CONSTANTS = {
  USER: {
    FETCH_FAILED: 'DOCUMENT_USER_FETCH_FAILED',
    RESPONSE_EMPTY: {
      key: 'DOCUMENT_USER_RESPONSE_EMPTY',
      message: 'El servicio de usuario no retornó información válida.'
    },
    USERNAME_MISSING: {
      key: 'DOCUMENT_USER_USERNAME_MISSING',
      message:
        'El servicio de usuario no retornó el nombre de usuario requerido para continuar.'
    },
    UNKNOWN_ERROR: {
      key: 'DOCUMENT_USER_UNKNOWN_ERROR',
      message: 'Ocurrió un error al consultar la información del usuario.'
    }
  },
  UPLOAD: {
    FAILED: 'DOCUMENT_UPLOAD_FAILED',
    TYPE_OPERATION_REQUIRED: {
      key: 'DOCUMENT_TYPE_OPERATION_REQUIRED',
      message: 'Es necesario un tipo de operación válido para subir documentos.'
    },
    FILE_INVALID: {
      key: 'DOCUMENT_FILE_INVALID',
      message: 'El archivo proporcionado no es válido para su carga.'
    },
    UNKNOWN_ERROR: {
      key: 'DOCUMENT_UPLOAD_UNKNOWN_ERROR',
      message: 'Ocurrió un error desconocido al subir el documento.'
    }
  },
  REPORT: {
    FETCH_FAILED: 'REPORT_LOAD_FETCH_FAILED',
    UNKNOWN_ERROR: {
      key: 'REPORT_LOAD_UNKNOWN_ERROR',
      message: 'Ocurrió un error desconocido al consultar el reporte de cargas.'
    }
  }
} as const;
